import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CcLineSummaryDto } from '../../../data/models/cc-line-summary-dto';
import { LineDetailsService } from '../../../services/line-details.service';
import { authorizationEnum } from '../layout/menu-sidebar/menu-sidebar.component';

@Component({
  selector: 'app-normal-container',
  templateUrl: './normal-container.component.html',
  styleUrls: ['./normal-container.component.scss'],
  providers: [MessageService]
})

export class NormalContainerComponent implements OnInit {
  @Input() fullLineInfo: CcLineSummaryDto;  //normal line /pair itself
  @Input() isPair: boolean;
  @Input() parentFullLineInfo: any;
  // selectedParentLineToShow: CcLineSummaryDto; //represent parent line incase pair
  showReachabilityDetails: boolean = false;


  constructor(private lineDetailsService: LineDetailsService, private messageService: MessageService) { }


  ngOnInit(): void {
    
    let showDelayDrop = sessionStorage.getItem(authorizationEnum.showReachabilityDetails);
    if (showDelayDrop == 'true') this.showReachabilityDetails = true;
    else this.showReachabilityDetails = false;
    console.log(this.fullLineInfo, this.isPair, this.parentFullLineInfo)
  }
  ngOnChanges() {
    this.fullLineInfo;
    this.isPair;
    
  }

  

}
